import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
	return (
		<Typewriter
			options={{
				strings: [
					"Software Engineer",
					"React Developer",
					"Django Developer",
					"FastAPI Developer",
					"Python Developer",
					"Full Stack Developer",
					"Freelancer",
					"Open Source Contributor",
				],
				autoStart: true,
				loop: true,
				deleteSpeed: 50,
			}}
		/>
	);
}

export default Type;
